import { Box, Theme, useTheme } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import ConfigurationWrapper from '../../components/shared/ConfigurationWrapper';
import PanelGeographical from '../../components/configuration/geographical/PanelGeographical';
import { ReactComponent as LocationIcon } from '../../assets/icons/Location.svg';
import { ReactComponent as PersonalisationIcon } from '../../assets/icons/Personalisation.svg';
import { ReactComponent as OrganisationIcon } from '../../assets/icons/Company_Organisation.svg';
import AlertBanner from '../../components/shared/banner/AlertBanner';
import { useSubscriptionContext } from '../../context/SubscriptionContext';
import { ExceededQuotaKey } from '../../lib/app/subscription';
import { useModuleDurationTracking } from '../../hooks/useModuleDurationTracking';
import { GroupContext } from '../../context/GroupContext';
import { CompanyContext } from '../../context/CompanyContext';

const ConfigurationGeographical: React.FC = () => {
  const { group } = useContext(GroupContext);
  const { company } = useContext(CompanyContext);

  if (!group || !company) return null;

  // Track module duration.
  useModuleDurationTracking('Configuration', 'Geographical', group.id, company.id);

  const theme: Theme = useTheme();
  const primary_blue: string = theme.palette.primary.main;
  const dark_teal: string = theme.palette.teal.dark;

  const { subscription, getExceededSubscriptionKeys } = useSubscriptionContext();
  const [showQuotaExceededAlert, setShowQuotaExceededAlert] = useState(false);

  // Close quota reached alert message.
  const handleClose = () => {
    setShowQuotaExceededAlert(false);
  };

  const exceeded_subscription_keys: Array<ExceededQuotaKey> = getExceededSubscriptionKeys([
    'entities'
  ]);

  // Validate subscription quota.
  useEffect(() => {
    if (exceeded_subscription_keys.length) {
      setShowQuotaExceededAlert(true);
    }
  }, [subscription]);

  return (
    <Box>
      <ConfigurationWrapper
        title="Geographical"
        icon={<LocationIcon height={50} fill={primary_blue} stroke={primary_blue} />}
        previous={{
          route: '/configuration/personalisation',
          label: 'Personalisation',
          icon: <PersonalisationIcon height={30} stroke={dark_teal} fill="none" strokeWidth={3} />
        }}
        next={{
          route: '/configuration/organisation',
          label: 'Organisation',
          icon: <OrganisationIcon height={30} fill={dark_teal} stroke={dark_teal} />
        }}
      >
        <AlertBanner
          severity="warning"
          message={`Quota reached for ${exceeded_subscription_keys
            .map((item) => `${item.label} (${subscription?.quota[item.key]})`)
            .join(', ')} allocated to your subscription.`}
          open={showQuotaExceededAlert && !!exceeded_subscription_keys.length}
          action={handleClose}
        />
        <PanelGeographical />
      </ConfigurationWrapper>
    </Box>
  );
};

export default ConfigurationGeographical;
